import React from 'react';
import Slider from 'react-slick';
import { ChevronLeft, ChevronRight } from 'lucide-react';

function Banner() {
  const bannerImagess = [
    'https://images.pexels.com/photos/2375131/pexels-photo-2375131.jpeg?auto=compress&cs=tinysrgb&w=2070',
    'https://images.pexels.com/photos/322207/pexels-photo-322207.jpeg?auto=compress&cs=tinysrgb&w=2070',
    'https://images.pexels.com/photos/303383/pexels-photo-303383.jpeg?auto=compress&cs=tinysrgb&w=2070',
    'https://images.pexels.com/photos/5632382/pexels-photo-5632382.jpeg?auto=compress&cs=tinysrgb&w=2070',
  ];
  
  const bannerImages = [
    {
      src: bannerImagess[0],
      title: "Super Deals",
      description: "Up to 50% products at best prices",
      buttonText: "Shop Now",
      bgGradient: "from-emerald-900/80"
    },
    {
      src: bannerImagess[1],
      title: "Premium Quality",
      description: "Discover handpicked premium quality products at best prices",
      buttonText: "Explore More",
      bgGradient: "from-blue-900/80"
    },
    {
      src: bannerImagess[2],
      title: "Special Offers",
      description: "Limited time deals on premium items",
      buttonText: "View Deals",
      bgGradient: "from-orange-900/80"
    },
    {
      src: bannerImagess[3],
      title: "Ultimate Pricing",
      description: "Limited time deals on premium items",
      buttonText: "View Deals",
      bgGradient: "from-orange-900/80"
    }
  ];

  // Function to handle button click and scroll
  const handleButtonClick = (buttonText) => {
    // Check if the button is "Shop Now"
    if (buttonText === "Shop Now") {
      // Scroll down by 10px
      window.scrollBy({
        top: 10,
        behavior: 'smooth'
      });
    }
  };

  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-4 top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/30 hover:bg-black/50 text-white transition-all duration-300"
      aria-label="Next slide"
    >
      <ChevronRight size={24} />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-4 top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/30 hover:bg-black/50 text-white transition-all duration-300"
      aria-label="Previous slide"
    >
      <ChevronLeft size={24} />
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: dots => (
      <div className="absolute bottom-4 left-0 right-0">
        <div className="flex items-center justify-center gap-2">
          {dots}
        </div>
      </div>
    ),
    customPaging: i => (
      <button
        className={`w-3 h-3 rounded-full transition-all duration-300 bg-white/50 hover:bg-white hover:scale-125`}
        aria-label={`Go to slide ${i + 1}`}
      />
    )
  };

  return (
    <div className="relative w-full overflow-hidden bg-gray-100">
      <div className="relative h-64 sm:h-96 md:h-[32rem] lg:h-[36rem] w-full">
        <Slider {...settings} className="h-full">
          {bannerImages.map((image, index) => (
            <div key={index} className="relative h-64 sm:h-96 md:h-[32rem] lg:h-[36rem]">
              <img
                src={image.src}
                alt={image.title}
                className="w-full h-full object-cover object-center"
              />
              <div className={`absolute inset-0 bg-gradient-to-r ${image.bgGradient} to-transparent`}>
                <div className="absolute bottom-8 sm:bottom-12 left-4 sm:left-8 md:left-12 lg:left-16 right-4 sm:right-8 md:right-12 lg:right-16">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
                    {image.title}
                  </h2>
                  <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-6 max-w-2xl">
                    {image.description}
                  </p>
                  <button 
                    className="bg-white hover:bg-gray-100 text-gray-900 px-6 py-3 rounded-full text-lg font-semibold transition-all duration-300 hover:shadow-lg"
                    onClick={() => handleButtonClick(image.buttonText)}
                  >
                    {image.buttonText}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Banner;
